import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Sidebar from "react-sidebar";
import Notes from "../../adminNotes/Notes";
import * as adminActions from "../../../../actions/admin.actions";
import * as commonActions from "../../../../actions/common.actions";
import * as projectActions from "../../../../actions/project.actions";
import close from "../../../../assets/images/close-icon.svg";

import styles from "./DrawerNotes.scss";

const customSidebar = {
  root: {
    position: "relative"
  },
  sidebar: {
    zIndex: 200,
    position: "fixed",
    background: "white",
    width: "460px",
    height: "100vh"
  },
  overlay: {
    zIndex: 100
  },
  dragHandle: {
    zIndex: 1
  }
};

class DrawerNotes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };

    this.submitNote = this.submitNote.bind(this);
  }

  fetchData() {
    switch (this.props.type) {
      case "company":
        this.props.adminActions.getAdminCompanyNotes(this.props.id);
        break;
      case "project":
        this.props.adminActions.getAdminProjectNotes(this.props.id);
        break;
      case "user":
        this.props.adminActions.getAdminUserNotes(this.props.id);
        break;
    }
  }

  componentDidMount() {
    if (this.props && this.props.id) {
      this.fetchData();
    }
  }

  componentDidUpdate() {
    if (this.props.notes) {
      this.props.totalUpdate(this.props.notes.length);
    }
  }

  submitNote(form) {
    let payload = null;

    switch (this.props.type) {
      case "company":
        payload = {
          company_id: this.props.id,
          note: form.note
        };

        this.props.adminActions.saveAdminCompanyNotes(payload);
        break;

      case "project":
        payload = {
          project_id: this.props.id,
          note: form.note
        };

        this.props.adminActions.saveAdminProjectNotes(payload);
        break;

      case "user":
        payload = {
          user_id: this.props.id,
          note: form.note
        };

        this.props.adminActions.saveAdminUserNotes(payload);
        break;
    }
  }

  renderSidebarHeader() {
    return (
      <div className={styles.sidebarHeader}>
        <h1 className={styles.title}>Admin Activity</h1>
        <button onClick={this.props.onSetOpen}>
          <img src={close} className={styles.closebutton} />
        </button>
      </div>
    );
  }

  renderNotes(notes) {
    return (
      <div className={styles.sidebar}>
        {this.renderSidebarHeader()}
        {notes && <Notes notes={notes} submitNote={this.submitNote} />}
      </div>
    );
  }

  render() {
    const { notes } = this.props;

    return (
      <Sidebar
        sidebar={this.renderNotes(notes)}
        pullRight={true}
        open={this.props.open}
        onSetOpen={this.props.onSetOpen}
        styles={customSidebar}
      >
        {""}
      </Sidebar>
    );
  }
}

const mapStateToProps = state => {
  return {
    notes: state.admin.notes,
    project: state.admin.project,
    member: state.admin.user
  };
};

const mapDispatchToProps = dispatch => {
  return {
    adminActions: bindActionCreators(adminActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    projectActions: bindActionCreators(projectActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DrawerNotes);



// WEBPACK FOOTER //
// ./src/routes/common/header/drawerNotes/DrawerNotes.js